import {find} from 'lodash'
import {useEffect, useState} from 'react'
import feathers from 'utility/client'

export const DeviceGroups = props => {
  const {
    groups: _groups,
    onChange = () => {},
    query = {},
    service
  } = props

  const [groups, setGroups] = useState([])
  const [list, setList] = useState([])

  const hydrate = () => {
    feathers.service(service).find({
      query: {
        ...query,
        $limit: -1
      }
    }).then(data => {
      setList(data)
    })
  }

  useEffect(() => {
    hydrate()
  }, [])

  useEffect(() => {
    if (_groups && _groups.length) {
      setGroups(_groups)
    }
  }, [_groups])

  const remove = index => {
    if (groups[index]?.home) {
      return
    }

    const _g = [...groups]
    _g.splice(index, 1)
    setGroups(_g)
    onChange(_g)
  }

  const add = ({target: {value}}) => {
    const group = list.find(g => g._id === value)
    if (!group) {
      return
    }

    const existing = find(groups, g => g._id._id === value)
    if (existing) {
      return
    }

    const _g = [...groups, {_id: group, home: !groups.length}]
    setGroups(_g)
    onChange(_g)
  }

  const makeHome = index => {
    const _g = [...groups]
    const homeIndex = _g.findIndex(g => g?.home)
    _g.splice(homeIndex, 1, {..._g[homeIndex], home: false})
    _g.splice(index, 1, {..._g[index], home: true})
    setGroups(_g)
    onChange(_g)
  }

  return (
    <div>
      <ul className="list-group mb-2">
        {groups.map((item, index) => (
          <li key={`device-group-${index}`} className="list-group-item">
            <div className="d-flex justify-content-between">
              <div>{item._id.name}</div>
              <h5 className="m-0 p-0">
                {item?.home ? (
                  <span className="badge badge-primary">Home Group</span>
                ) : (
                  <button
                    type="button"
                    className="btn btn-link btn-sm my-0 mx-2 p-0"
                    onClick={() => makeHome(index)}
                  >
                    Set as home group
                  </button>
                )}

                {!item?.home && (
                  <span className="badge badge-secondary pointer" onClick={() => remove(index)}>
                    Remove
                  </span>
                )}
              </h5>
            </div>
          </li>
        ))}
      </ul>
      <label>
        <label className="form-label mb-0">Add device to group</label>
      </label>
      <select className="form-control" onChange={add}>
        <option disabled selected value>
          -- Select group --
        </option>
        {list.map(item => (
          <option key={item._id} value={item._id}>
            {item.name}
          </option>
        ))}
      </select>
    </div>
  )
}
